import { formatMoney } from "@/lib/format";

export function CurrencyDisplay({ value }: { value: number | null | undefined }) {
  return <span>{formatMoney(value)}</span>;
}
